/** Renseigne `coordinates` [lat, lng] via le Geocoder Google lorsqu'elles manquent (ville + code postal). */
export async function geocodeExpertsForMap<T extends { postalCode?: string; city?: string; coordinates?: [number, number] }>(
  experts: T[],
  geocoder: google.maps.Geocoder
): Promise<T[]> {
  return Promise.all(
    experts.map(
      (expert) =>
        new Promise<T>((resolve) => {
          if (expert.coordinates?.length === 2) {
            resolve(expert);
            return;
          }
          const q = [expert.postalCode, expert.city].filter(Boolean).join(' ').trim();
          if (!q) {
            resolve(expert);
            return;
          }
          geocoder.geocode({ address: `${q}, France` }, (results, status) => {
            if (status === 'OK' && results?.[0]) {
              const loc = results[0].geometry.location;
              resolve({
                ...expert,
                coordinates: [loc.lat(), loc.lng()],
              });
            } else {
              resolve(expert);
            }
          });
        })
    )
  );
}
